import { Injectable } from '@angular/core';
import { SessionService } from '../../store/services/session.service';
import { CanActivate, Router } from '@angular/router';

@Injectable()
export class NonImpersonatingGuard implements CanActivate {
  constructor(
    private readonly sessionService: SessionService,
    private readonly router: Router,
  ) {
  }

  canActivate(): boolean {
    if (this.sessionService.isImpersonating()) {
      this.router.navigate(['/']);
      return false;
    }
    return true;
  }
}